import { render, staticRenderFns } from "./One.vue?vue&type=template&id=227b8c07"
import script from "./One.vue?vue&type=script&lang=js"
export * from "./One.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../deps/0/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports